import { makeHasGate } from 'app/modules/gates/selectors'
import { properties } from 'app/modules/org/selectors'

export const root = state => state.get('rules')

export const rules = state => root(state).get('rules')
export const rulesForIds = state => root(state).get('rulesForIds')
export const onCall = state => root(state).get('onCall')
export const rulesLoading = state => root(state).get('rulesLoading')
export const activeRule = state => root(state).get('activeRule')
export const flatRules = state => root(state).get('flatRules')
export const userIdsForRules = state => root(state).get('userIdsForRules')
export const rulesLoaded = state => root(state).get('rulesLoaded')

export const makeRule = () => (state, props) => {
  const result = _.find(rules(state), rule => rule.item.id === props.ruleId)
  if (result) {
    return result.item
  }
}

export const getRuleById = (state, props) => {
  const result = _.find(rules(state), rule => rule.item.id === props.ruleId)
  if (result) {
    return result
  }
}
const roundRobinStatusByKey = state => {
  return root(state).get('roundRobinStatusByKey')
}

const getRoundRobinByKey = (state, key) => {
  return roundRobinStatusByKey(state).get(key, new Map())
}

export const getIsRoundRobinLoadPending = (state, key) => getRoundRobinByKey(state, key).get('loading')

export const getRoundRobinLoadFailed = (state, key) => !!getRoundRobinByKey(state, key).get('err')

export const getRoundRobinData = (state, key) => getRoundRobinByKey(state, key).get('data')

export const hasVisualRoutingBuilder = (state) => makeHasGate('HAS_VISUAL_ROUTING_BUILDER')(state)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/rules/selectors.js